import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */

export const _frontmatter = {};
const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};
const ProjectCard = makeShortcode("ProjectCard");
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <h1>{`Projects`}</h1>
    <ProjectCard title="Awesome Project" thumbnailPath="https://cdn.pixabay.com/photo/2020/01/17/13/18/sheep-4772994_960_720.jpg" link="https://www.jhipster.tech/" bg="#00B2FF" textColor="white" mdxType="ProjectCard">
  Then came the night of the first falling star. It was seen early in the morning, rushing over Winchester eastward, a
  line of flame high in the atmosphere. Hundreds must have seen it and taken it for an ordinary falling star. It seemed
  that it fell to earth about one hundred miles east of him.
    </ProjectCard>
    <ProjectCard title="Amazing Project" thumbnailPath="https://cdn.pixabay.com/photo/2020/07/11/08/00/deer-5393082_960_720.jpg" link="https://opencollective.com/" bg="#B4FFE5" textColor="black" mdxType="ProjectCard">
   He sat across from her trying to imagine it was the first time. It wasn't. Had it been a hundred? It quite possibly could
   have been. Two hundred? Probably not. His mind wandered until he caught himself and again tried to imagine it was the first time.
    </ProjectCard>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      